import store from '../store';
import { isMarketplacePlace } from './marketplacePlace';

export function isMissingPlatformSubscription(
    subscription = store.state.auth.platformSubscription,
    place = store.state.auth.place,
) {
    if (!place || isMarketplacePlace(place) || isPlatformExempt(subscription, place)) {
        return false;
    }

    if (subscription?.has_subscription === false) {
        return true;
    }

    if (place.platform_subscription_has_subscription === false) {
        return true;
    }

    // Assinatura confirmada (API ou lista de places) — não exibir aviso
    if (subscription?.has_subscription === true) {
        return false;
    }

    if (place.platform_subscription_has_subscription === true) {
        return false;
    }

    const status = subscription?.status ?? place?.platform_subscription_status;

    if (status != null) {
        return false;
    }

    // Estado desconhecido (ex.: falha ao carregar) — não inferir ausência de assinatura
    return false;
}

export function isSubscriptionBlockedForBilling(place) {
    if (!place?.platform_subscription_is_blocked) {
        return false;
    }

    if (isMarketplacePlace(place) || place.platform_subscription_exempt) {
        return false;
    }

    // Local sem assinatura nenhuma volta com status null e mesmo assim é
    // bloqueado pela API — antes esse caso escapava e o acesso quebrava.
    if (place.platform_subscription_has_subscription === false) {
        return true;
    }

    return place.platform_subscription_status != null;
}

export function isTrialFullAccess() {
    const subscription = store.state.auth.platformSubscription;
    const place = store.state.auth.place;

    return subscription?.status === 'trial'
        || place?.platform_subscription_status === 'trial';
}

export function isPlatformExempt(
    subscription = store.state.auth.platformSubscription,
    place = store.state.auth.place,
) {
    return Boolean(subscription?.exempt || place?.platform_subscription_exempt);
}

export function usesSelfServiceBilling() {
    const subscription = store.state.auth.platformSubscription;

    if (!subscription) {
        return true;
    }

    if (subscription.exempt) {
        return false;
    }

    if (subscription.billing_mode === 'manual') {
        return false;
    }

    return subscription.plan?.slug !== 'enterprise';
}
